@if (sortiment == '') {
  <i class="fa {{icon}} text-muted" style="margin-right: 5px"></i>
} @else {
  <i class="fa {{icon}}" style="margin-right: 5px" [pTooltip]="name + ': ' + sortiment"> </i>
}

